/* ==========================================================================
   Giostra 3D per la lista collezioni
   --------------------------------------------------------------------------
   Sostituisce lo Swiper creato dal tema con una piattaforma rotante: le
   collezioni orbitano attorno a un asse verticale, quella davanti è grande,
   a fuoco e col neon acceso.

   Non si usa transform-style: preserve-3d. Con il 3D vero del browser i
   cerchi si girerebbero di taglio diventando ellissi e i nomi ruoterebbero
   illeggibili. Qui la posizione sull'orbita è calcolata e proiettata:
   x = sin(a) * raggio, profondità = cos(a), e da quella derivano scala,
   sfocatura, luminosità e ordine di sovrapposizione. I cerchi restano
   cerchi e i nomi restano dritti.

   theme.min.js non viene modificato. Se la giostra va disattivata si
   richiama BlsSettingsSwiper.BlsCarousel, la funzione del tema, e torna il
   carousel originale.
   ========================================================================== */
(function () {
  'use strict';

  var SELECTOR = '[data-collection-3d="true"]';
  /* La giostra gira a ogni larghezza, ma con tre tarature diverse:

     le proporzioni si adattano con continuità alla larghezza disponibile
     (vedi measure), e sotto i 1024px resta visibile il nome della sola
     collezione in primo piano perché otto etichette affiancate non entrano. */
  var MIN_WIDTH = 300;

  function num(root, key, fallback) {
    var v = parseFloat(root.getAttribute('data-cc3d-' + key));
    return isNaN(v) ? fallback : v;
  }

  function flag(root, key) {
    return root.getAttribute('data-cc3d-' + key) === 'true';
  }

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function wants3d(root) {
    return !!window.Swiper && root.clientWidth >= MIN_WIDTH;
  }

  function revert(root) {
    if (root.dataset.cc3dState !== 'on') return;
    if (root.cc3dStop) root.cc3dStop();
    if (root.swiper && root.swiper.destroy) root.swiper.destroy(true, true);
    root.classList.remove('cc3d-on', 'cc3d-neon', 'cc3d-dragging');
    root.dataset.cc3dState = 'off';
    var wrap = root.querySelector('.swiper-wrapper');
    if (wrap) wrap.style.height = '';
    [].forEach.call(root.querySelectorAll('.swiper-slide'), function (s) {
      s.style.cssText = '';
      s.classList.remove('cc3d-front');
    });
    if (window.BlsSettingsSwiper && window.BlsSettingsSwiper.BlsCarousel) {
      window.BlsSettingsSwiper.BlsCarousel(root);
    }
  }

  function build(root) {
    if (root.dataset.cc3dState === 'on') return;
    if (root.swiper && root.swiper.destroy) root.swiper.destroy(true, true);

    var wrap = root.querySelector('.swiper-wrapper');
    var slides = [].slice.call(root.querySelectorAll('.swiper-slide'));
    var N = slides.length;
    if (!wrap || N < 3) return;

    root.classList.add('cc3d-on');
    if (flag(root, 'neon')) root.classList.add('cc3d-neon');
    root.dataset.cc3dState = 'on';

    var speed = num(root, 'speed', 14);
    var radiusMax = num(root, 'radius', 380);
    var depth = num(root, 'depth', 55) / 100;
    var tilt = num(root, 'tilt', 46);
    var blurMax = flag(root, 'blur') ? num(root, 'blurmax', 35) / 10 : 0;
    var sizeMax = num(root, 'size', 170);

    var base = 0, vel = 0, dragging = false, moved = 0;
    var lastX = 0, lastT = 0, prev = 0, raf = null, visible = true;
    var still = reducedMotion();

    /* la giostra si adatta alla larghezza reale invece di sfondare il contenitore */
    var radius = radiusMax, size = sizeMax, tiltNow = tilt, blurNow = blurMax;
    function measure() {
      var w = root.clientWidth;
      /* Formule continue invece di rami separati per telefono e desktop: due
         tarature distinte non si incontravano alla soglia e il cerchio saltava
         da 200 a 124px attraversandola.

         Il diametro resta quello scelto nel theme editor finché lo schermo lo
         consente, e si restringe solo quando non ci sta: la collezione davanti
         ha così la stessa presenza ovunque. Orbita, arco e sfocatura crescono
         invece con la larghezza, perché sono loro a volere spazio. */
      size = Math.min(sizeMax, w * 0.46);
      /* L'orbita non può mai essere più stretta del cerchio, altrimenti le
         collezioni si ammassano al centro invece di distribuirsi: su un
         telefono da 390px l'orbita valeva 117px contro un cerchio da 170, e
         il vicino finiva sovrapposto di 80px a quello in primo piano.
         Il pavimento garantisce spazio libero fra il fronte e il vicino a
         ogni larghezza; su schermo stretto le collezioni laterali escono
         semplicemente dai bordi, che è il comportamento giusto. */
      radius = Math.max(size * 1.5, Math.min(radiusMax, w * 0.30));
      var room = Math.min(1, w / 900);
      tiltNow = tilt * room;
      blurNow = blurMax * room;   /* la sfocatura è cara da disegnare: sui telefoni si alleggerisce da sé */
      /* disco + escursione verticale dell'arco + spazio per nome e conteggio */
      wrap.style.height = Math.round(size + tiltNow * 2 + 96) + 'px';
    }

    function layout() {
      var bestI = 0, bestZ = -2;
      for (var i = 0; i < N; i++) {
        var r = (base + i * 360 / N) * Math.PI / 180;
        var z = Math.cos(r);
        var t = (z + 1) / 2;
        var s = slides[i];
        s.style.width = size + 'px';
        s.style.marginLeft = (-size / 2) + 'px';
        s.style.marginTop = (-size / 2) + 'px';
        s.style.transform =
          'translate(' + (Math.sin(r) * radius).toFixed(1) + 'px,' +
          (z * tiltNow).toFixed(1) + 'px) scale(' + ((1 - depth) + depth * t).toFixed(3) + ')';
        s.style.opacity = (0.30 + 0.70 * t).toFixed(3);
        s.style.filter = (blurNow > 0 ? 'blur(' + (blurNow * (1 - t)).toFixed(2) + 'px) ' : '') +
                         'brightness(' + (0.42 + 0.58 * t).toFixed(2) + ')';
        s.style.zIndex = Math.round(t * 1000);
        s.classList.remove('cc3d-front');
        if (z > bestZ) { bestZ = z; bestI = i; }
      }
      slides[bestI].classList.add('cc3d-front');
    }

    function tick(now) {
      var dt = Math.min(0.05, (now - prev) / 1000);
      prev = now;
      if (!dragging) {
        if (Math.abs(vel) > 0.01) {
          base += vel * dt;
          vel *= Math.pow(0.12, dt);        /* attrito */
        } else if (!still) {
          base += speed * dt;
        }
      }
      layout();
      raf = requestAnimationFrame(tick);
    }

    function start() {
      if (raf) return;
      prev = performance.now();
      raf = requestAnimationFrame(tick);
    }
    function stop() {
      if (!raf) return;
      cancelAnimationFrame(raf);
      raf = null;
    }
    root.cc3dStop = stop;

    root.addEventListener('pointerdown', function (e) {
      dragging = true; moved = 0;
      root.classList.add('cc3d-dragging');
      lastX = e.clientX; lastT = performance.now();
      try { root.setPointerCapture(e.pointerId); } catch (err) {}
    });

    root.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var now = performance.now(), dx = e.clientX - lastX, dt = Math.max(1, now - lastT);
      moved += Math.abs(dx);
      base += dx * 0.35;
      vel = (dx * 0.35) / (dt / 1000);
      lastX = e.clientX; lastT = now;
    });

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      /* la classe resta un attimo così il click che segue un trascinamento
         non apre la collezione sbagliata */
      setTimeout(function () { root.classList.remove('cc3d-dragging'); }, moved > 6 ? 60 : 0);
    }
    root.addEventListener('pointerup', endDrag);
    root.addEventListener('pointercancel', endDrag);

    /* le frecce del tema, se presenti, fanno avanzare di una posizione */
    var next = root.querySelector('.swiper-button-next');
    var prevBtn = root.querySelector('.swiper-button-prev');
    if (next) next.addEventListener('click', function () { vel = 0; base -= 360 / N; });
    if (prevBtn) prevBtn.addEventListener('click', function () { vel = 0; base += 360 / N; });

    /* ferma il ciclo quando la sezione non è a schermo: è una home, non
       deve consumare batteria mentre l'utente legge il resto della pagina */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) start(); else stop();
      }, { rootMargin: '120px' }).observe(root);
    } else {
      start();
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else if (visible) start();
    });

    measure();
    layout();
    start();

    var rt = null;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { measure(); layout(); }, 150);
    });
  }

  function sync(root) {
    if (wants3d(root)) build(root); else revert(root);
  }

  function syncAll(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(sync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { syncAll(); });
  } else {
    syncAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var scope = e.target || document;
    scope.querySelectorAll(SELECTOR).forEach(function (r) { r.dataset.cc3dState = 'off'; });
    setTimeout(function () { syncAll(scope); }, 0);
  });
})();
